import React from 'react';
import { JSONTree } from 'react-json-tree';
import { type ConfigurationKey } from '../graphql/useGetConfigurationKey';

export type ConfigurationDetailProps = ConfigurationKey & {
  modifyData?: (jsonStringLike: string) => void;
  refetch?: () => void;
};

export const ConfigurationDetail: React.FC<ConfigurationDetailProps> = ({
  key,
  value,
}: ConfigurationDetailProps) => {
  return (
    <div>
      <h2>{key}</h2>
      {/* Use JSON visualizer */}
      <div className="w-[100%]">
        <JSONTree
          data={JSON.parse(value ?? '{}')}
          hideRoot
          shouldExpandNodeInitially={() => true}
        />
      </div>
    </div>
  );
};
